/* ============================================
   Service & Support Tabs — service-support.js
   ============================================ */

(function () {
  'use strict';

  // ▸ REPLACE WITH YOUR DEPLOYED /exec URL
  var SHEET_URL = 'https://script.google.com/macros/s/AKfycbyqzsuYVzIkkL5w3oKV3jdkVUvaAmoYU6eoPf85xnPURIGcv2TGgLmYiIJUIs1yG-jTlA/exec';

  // contact[tags] value → formName key in Apps Script
  var TAG_TO_FORM_NAME = {
    'service-request'       : 'ServiceRequest',
    'sales-support'         : 'SalesSupport',
    'customer-support'      : 'CustomerSupport',
    'complaint-registration': 'ComplaintRegistration'
  };

  function getUrlParam(name) {
    return new URLSearchParams(window.location.search).get(name) || '';
  }

  // "+91 98765-43210", "098765 43210", "9876543210" -> "+919876543210", so the same number is
  // always recorded the same way. Anything that is not a plain Indian mobile is only tidied.
  function normalizePhone(value) {
    var v = (value || '').trim();
    var digits = v.replace(/[\s\-()]/g, '');
    var m = digits.match(/^(?:\+?91|0)?([6-9]\d{9})$/);
    return m ? '+91' + m[1] : v;
  }

  function normalizeFields(form) {
    Array.prototype.forEach.call(form.querySelectorAll('input[type="tel"]'), function (el) {
      el.value = normalizePhone(el.value);
    });
  }

  // Runs only from the submit event, i.e. after the browser has already validated the form, so
  // autofilled or half-filled forms are never blocked. It only stops a second click while the
  // page is reloading (double-click = two enquiries).
  function lockSubmit(form) {
    var btn = form.querySelector('button[type="submit"]');
    if (!btn || btn.disabled) return;
    btn.dataset.label = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Submitting\u2026';
  }

  function unlockSubmits() {
    document.querySelectorAll('.ss-form button[type="submit"]').forEach(function (btn) {
      if (btn.dataset.label) { btn.textContent = btn.dataset.label; delete btn.dataset.label; }
      btn.disabled = false;
    });
  }

  // Coming back via the browser Back button restores the page from cache with the button locked.
  window.addEventListener('pageshow', function (e) { if (e.persisted) unlockSubmits(); });

  function postToAppsScript(form) {
    // Skip if HTML5 validation would block Shopify's submit anyway
    if (typeof form.checkValidity === 'function' && !form.checkValidity()) return;

    var tagInput = form.querySelector('input[name="contact[tags]"]');
    if (!tagInput) return;
    var formName = TAG_TO_FORM_NAME[tagInput.value];
    if (!formName) return;

    var data = { formName: formName };

    Array.prototype.forEach.call(form.elements, function (el) {
      if (!el.name) return;
      var m = el.name.match(/^contact\[(.+)\]$/);
      if (!m) return;
      var key = m[1];
      if (key === 'tags' || key === 'form_type') return;
      data[key] = el.value;
    });

    data.utm_source   = getUrlParam('utm_source');
    data.utm_medium   = getUrlParam('utm_medium');
    data.utm_campaign = getUrlParam('utm_campaign');
    data.gclid        = getUrlParam('gclid');

    try {
      fetch(SHEET_URL, {
        method   : 'POST',
        mode     : 'no-cors',
        keepalive: true,
        body     : JSON.stringify(data)
      });
    } catch (e) { /* swallow — Shopify form continues regardless */ }
  }

  function initServiceSupportTabs() {
    const sections = document.querySelectorAll('.ss-section');

    sections.forEach(function (section) {
      const tabs   = section.querySelectorAll('.ss-tab');
      const panels = section.querySelectorAll('.ss-panel');

      if (!tabs.length || !panels.length) return;

      // ── Mirror form submissions to Apps Script ──────────────
      section.querySelectorAll('.ss-form').forEach(function (form) {
        if (form.dataset.appsScriptBound) return; // prevent double-binding
        form.dataset.appsScriptBound = 'true';
        // Order matters: tidy the phone numbers first so the Apps Script copy matches.
        form.addEventListener('submit', function () {
          normalizeFields(form);
          postToAppsScript(form);
          lockSubmit(form);
        });
      });

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          const targetId = 'panel-' + tab.getAttribute('data-tab');

          // Remove active from all tabs & panels
          tabs.forEach(function (t) {
            t.classList.remove('active');
            t.setAttribute('aria-selected', 'false');
          });
          panels.forEach(function (p) {
            p.classList.remove('active');
          });

          // Activate clicked tab
          tab.classList.add('active');
          tab.setAttribute('aria-selected', 'true');

          // Activate matching panel
          const targetPanel = section.querySelector('#' + targetId);
          if (targetPanel) {
            targetPanel.classList.add('active');

            // Smooth scroll to wrapper on mobile
            if (window.innerWidth <= 600) {
              section.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
          }
        });
      });

      // After Shopify reloads the page the URL ends in the form's id (#ss-form-...). Reopen that
      // tab so the visitor sees their own success / error message, not the default tab.
      if (window.location.hash) {
        var anchored = null;
        try { anchored = section.querySelector(window.location.hash); } catch (err) { /* bad hash */ }
        var anchoredPanel = anchored && anchored.closest('.ss-panel');
        if (anchoredPanel) {
          tabs.forEach(function (t) {
            if ('panel-' + t.getAttribute('data-tab') === anchoredPanel.id) t.click();
          });
          section.scrollIntoView({ block: 'start' });
        }
      }

      // Keyboard navigation (Left / Right arrow keys)
      tabs.forEach(function (tab, index) {
        tab.addEventListener('keydown', function (e) {
          let newIndex = null;
          if (e.key === 'ArrowRight') newIndex = (index + 1) % tabs.length;
          if (e.key === 'ArrowLeft')  newIndex = (index - 1 + tabs.length) % tabs.length;
          if (newIndex !== null) {
            tabs[newIndex].focus();
            tabs[newIndex].click();
          }
        });
      });
    });
  }

  // Init on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initServiceSupportTabs);
  } else {
    initServiceSupportTabs();
  }

  // Re-init for Shopify Theme Editor live reloads
  document.addEventListener('shopify:section:load', initServiceSupportTabs);

})();